import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslate} from "../../../system/useTranslate";
import {useDeliverable} from "../../../models/deliverable/use-deliverable";
import {useProject} from "../../../models/project/use-project";
import {useTask} from "../../../models/task/use-task";
import {setWorkspaceMembership} from "../../../system/app-slice";
import BoxHeader from "../../components/box-header";
import Icon from "../../../system/components/icon";
import Table from "../../../system/components/table";
import DeliverableDialog from "../../tasks/deliverable-dialog";
import DeliverableSidebar from "../components/deliverable-sidebar";
import AvatarGroup from "../../../system/components/avatar-group";
import Avatar from "../../../system/components/avatar";
import {Avatar as PrimeAvatar} from "primereact/avatar";
import {Button} from "primereact/button";
import {DataView} from "primereact/dataview";
import {fileThumbnail} from "../../../system/utils";
import Span from "../../../system/components/span";
import FileSidebar from "../components/file-sidebar";
import {useNavigate} from "react-router-dom";
import {Divider} from "primereact/divider";
import {useGoal} from "../../../models/goal/use-goal";
import ProjectUpdatesList from "../components/project-updates-list";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";
import Can from "../../../system/can";
import {OverlayPanel} from "primereact/overlaypanel";
import MultiSelectGoals from "../../goals/components/multi-select-goals";
import goal from "../../goals/goal/goal";
import MultiSelectMembers from "../../tasks/components/multi-select-members";
import ProjectProgressChart from "./project-progress-chart";
import {usePermission} from "../../../system/usePermission";
import AddLinkDialog from "../components/add-link-dialog";
import {resolveUrl} from "../../../system/app-config";
import {RichTextView} from "../../../system/components/rich-text";


function Identification({projectData, tasks, updateTask, createTask, updateProject, refreshProject}) {
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    const [deliverableDialogVisible, setDeliverableDialogVisible] = useState(false);
    const [selectedDeliverable, setSelectedDeliverable] = useState();
    const deliverable = useDeliverable();
    const goal = useGoal();
    const project = useProject();
    const task = useTask();
    const dispatch = useDispatch();
    const goalRef = useRef();
    const projectRef = useRef();
    const memberRef = useRef();
    const permission = usePermission();
    const [addLinkVisible, setAddLinkVisible] = useState(false);


    useEffect(() => {
        if (projectData) {
            permission.setScopeId(projectData?.documentId);
            permission.setScopeRolePermissions(projectData?.rolesConfig);
        }
    }, [projectData]);


    // useEffect(() => {
    //     console.log(projectData)
    // }, []);

    const createDeliverable = async (deliverableData) => {
        let _data = await deliverable.createDeliverable({...deliverableData});
        let _projects = await project.getProjects(workspaceMembershipData?.workspace.id);
        dispatch(setWorkspaceMembership({
            ...workspaceMembershipData,
            workspace: {...workspaceMembershipData.workspace, projects: _projects}
        }));
        await refreshProject?.();
        setDeliverableDialogVisible(false);
    }
    const updateDeliverable = async (deliverableData, updateData) => {
        let _data = await deliverable.updateDeliverable(deliverableData.documentId, updateData);
        console.log(_data);
        let _projects = await project.getProjects(workspaceMembershipData?.workspace.id);
        dispatch(setWorkspaceMembership({
            ...workspaceMembershipData,
            workspace: {...workspaceMembershipData.workspace, projects: _projects}
        }));
        await refreshProject?.();

        await refreshProject();
    }
    const updateLinkedAttachments = async (e) => {
        if (e.linkTo === "project") {
            let toggleProjectAttachment = e.fileInfo?.related.find(r => r.id === projectData?.id) ? "disconnect" : "connect";
            let result = await updateProject?.(projectData, {attachments: {[toggleProjectAttachment]: [{id: e?.fileInfo?.id}]}});
            // await getAttachments();
            return result;
        }
    }


    const modifyMembers = (data) => {

        if (data?.status === "added") {
            updateProject(projectData, {members: {connect: [data.member.id]}}, {
                members: [data.member],
                status: data?.status
            })
        }
        if (data?.status === "removed") {
            updateProject(projectData, {members: {disconnect: [data.member.id]}}, {members: [data.member]})
        }
    }
    const modifyProjects = (data) => {
        if (data?.status === "added") {
            updateProject(projectData, {projects: {connect: [data.projectData.id]}})
        }
        if (data?.status === "removed") {
            updateProject(projectData, {projects: {disconnect: [data.projectData.id]}})
        }
    }
    const modifyGoals = (data) => {
        if (data?.status === "added") {
            updateProject(projectData, {goals: {connect: [data.goalData.id]}})
        }
        if (data?.status === "removed") {
            updateProject(projectData, {goals: {disconnect: [data.goalData.id]}})
        }
    }

    const getMilestoneRowClassName = (row) => {
        const status = row?.deliverableStatus;
        const doneAt = row?.doneAt;
        const baseClass = "cursor-pointer transition-colors deliverable-sidebar-trigger";

        if (status === "done") {
            return `surface-100 text-400 line-through ${baseClass}`;
        }

        if (!doneAt) {
            return baseClass;
        }

        const now = new Date();
        const dueDate = new Date(doneAt);
        const diff = dueDate.getTime() - now.getTime();
        const threeDays = 3 * 24 * 60 * 60 * 1000;

        if (diff < 0) {
            return `bg-red-50 text-red-700 ${baseClass}`;
        }

        if (diff <= threeDays) {
            return `bg-orange-50 text-orange-700 ${baseClass}`;
        }

        return baseClass;
    };


    return (
        <div className="h-full flex bg-white">
            {/* ستون اصلی - فقط این اسکرول دارد */}
            <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hide flex flex-column">
                <div className="flex p-4">
                    <CardView className="surface-50">
                        <div className="flex gap-4 p-3">
                            {/*<div className="flex-1 flex flex-column gap-2">*/}
                            {/*    <BoxHeader icon={<Icon icon="mi mi:lightbulb" className="text-lg"/>} title={translate("strategic-hypothesis")} className="text-sm text-primary"/>*/}
                            {/*    <div className="flex flex-column p-3 bg-primary-50 border-primary-300 border-1 border-round-lg gap-2">*/}
                            {/*        <span className="font-bold">{translate("hypothesis")}:</span>*/}
                            {/*        <span className="line-height-4">{projectData?.hypothesis}</span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="flex-1 flex flex-column gap-2">
                                <BoxHeader icon={<Icon icon="mi mi:description" className="text-lg"/>}
                                           title={translate("project-description")} className="text-sm"/>
                                <div className="flex flex-column p-1 border-round-lg gap-2">
                                    <RichTextView className="line-height-4" value={projectData?.description}/>
                                </div>
                            </div>
                        </div>
                    </CardView>
                </div>
                <div className="flex p-4 pt-0">
                    <CardView className="surface-50">
                        <div className="flex gap-2">
                            <div className="flex-1 flex flex-column gap-2 pb-3">
                                <BoxHeader icon={<Icon icon="mi mi:check_box" className="text-lg text-primary"/>}
                                           title={translate("milestones")} className="text-sm p-3"
                                           left={<Can permission="create-milestone"
                                                      scopeRolePermissions={projectData?.rolesConfig}
                                                      scopeId={projectData?.documentId}><Icon icon="mi mi:add"
                                                                                              className="text-primary"
                                                                                              onClick={() => {
                                                                                                  setDeliverableDialogVisible(true)
                                                                                              }}/></Can>}/>
                                <Table
                                    dataKey="documentId"
                                    rowClassName={getMilestoneRowClassName}
                                    onRowClick={(e) => {
                                        setSelectedDeliverable(e.value)
                                    }}
                                    value={projectData?.deliverables?.filter(d => !d.archivedAt).map(d => ({
                                        ...d,
                                        progress: `${task.tasksPercent(
                                            tasks.filter(task => task.deliverables?.some(td => td.id === d.id)),
                                            "done"
                                        ).percent}`
                                    }))}
                                    fields={deliverable.prepareTable({config, actions: {}}).fields}
                                    fieldsConfig={deliverable.prepareTable({config, actions: {}}).fieldsConfig}
                                    showHeader={false}
                                    showFooter={false}
                                    style={null}
                                />

                            </div>
                            <DeliverableDialog payload={{projectData}} visible={deliverableDialogVisible}
                                               setVisible={setDeliverableDialogVisible} onSubmit={(e) => {
                                createDeliverable(e)
                            }}/>
                            <DeliverableSidebar disabled={!permission.can("edit-milestone")} tasks={tasks}
                                                updateTask={updateTask}
                                                createTask={createTask}
                                                selectedDeliverable={projectData?.deliverables.find(deliverable => deliverable.id === selectedDeliverable?.id)}
                                                setSelectedDeliverable={setSelectedDeliverable} onSubmit={(e) => {
                                updateDeliverable(selectedDeliverable, e)
                            }}/>


                        </div>
                    </CardView>
                </div>
                <div className="flex p-4 pt-0 gap-4">
                    <CardView className="surface-50">
                        <div className="flex h-full gap-2 align-items-start">
                            <div className="flex-1 flex flex-column gap-2 pb-3 ">
                                <BoxHeader
                                    left={<Can permission="modify-project-settings" scopeId={projectData?.documentId}
                                               scopeRolePermissions={projectData?.rolesConfig}><Button
                                        type="button"
                                        text
                                        rounded
                                        severity="secondary"
                                        aria-label={translate("related-goals")}
                                        className="p-0 shadow-none outline-none"
                                        style={{outline: "none", boxShadow: "none"}}
                                        onClick={(e) => {
                                            goalRef.current.toggle(e)
                                        }}><Icon icon="mi mi:add" className="text-xl text-primary"/></Button></Can>}
                                    icon={<Icon icon="mi mi:flag" className="text-lg text-400"/>}
                                    title={translate("related-goals")} className="text-sm p-3 pb-0"/>
                                <OverlayPanel
                                    pt={{root: () => ({className: "p-0 rtl"}), content: () => ({className: "p-0"})}}
                                    ref={goalRef}>
                                    <MultiSelectGoals onChange={(e) => {
                                        modifyGoals(e)
                                    }} options={workspaceMembershipData?.workspace?.goals} value={projectData?.goals}/>
                                </OverlayPanel>
                                <div className="pl-3 pr-3 flex flex-column gap-1">
                                    {projectData?.goals?.map(g => (
                                        <div
                                            className="surface-100 border-round-lg p-2 flex justify-content-between align-items-center">
                                            <span>{g.title}</span>
                                            <span
                                                className={`${goal.statusClassName(g.goalStatus, true, true)}`}>{translate(g.goalStatus)}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </CardView>
                    <CardView className="surface-50 h-fit">
                        <div className="flex h-full gap-2 align-items-start">
                            <div className="flex-1 flex flex-column gap-2 pb-3">
                                <BoxHeader
                                    left={<Can permission="modify-project-settings" scopeId={projectData?.documentId}
                                               scopeRolePermissions={projectData?.rolesConfig}><span
                                        className="cursor-pointer" onClick={(e) => {
                                    }}><Icon icon="mi mi:add" className="text-xl text-primary"/></span></Can>}
                                    icon={<Icon icon="mi mi:folder_special" className="text-lg text-400"/>}
                                    title={translate("portfolios")} className="text-sm p-3 pb-0"/>

                                <div className="pl-3 pr-3 flex flex-column gap-1">
                                    {projectData?.portfolios?.map(portfolio => (
                                        <div className="flex gap-2 align-items-center">
                                            <span className="bg-blue-500 border-round-lg h-2rem"
                                                  style={{width: '8px'}}/>
                                            <div className="flex flex-column">
                                                <span>{portfolio.title}</span>
                                                <span className="text-300">{portfolio.owner?.member?.fullname}</span>
                                            </div>
                                            {/*<span>{portfolio.goalStatus}</span>*/}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </CardView>
                    <CardView className="surface-50 h-fit">
                        <div className="flex h-full gap-2 align-items-start">
                            <div className="flex-1 flex flex-column gap-2 pb-3">
                                <BoxHeader
                                    left={<Can permission="manage-project-members" scopeId={projectData?.documentId}
                                               scopeRolePermissions={projectData?.rolesConfig}><span
                                        className="cursor-pointer" onClick={(e) => {
                                        memberRef.current.toggle(e)
                                    }}><Icon icon="mi mi:person_add" className="text-xl text-primary"/></span></Can>}
                                    icon={<Icon icon="mi mi:people" className="text-lg text-400"/>}
                                    title={translate("project-members")} className="text-sm p-3 pb-0"/>
                                <OverlayPanel
                                    pt={{root: () => ({className: "p-0 rtl"}), content: () => ({className: "p-0"})}}
                                    ref={memberRef}>
                                    <MultiSelectMembers onChange={(e) => {
                                        modifyMembers(e)
                                    }} options={workspaceMembershipData?.workspace?.workspace_memberships}
                                                        value={projectData?.members}/>
                                </OverlayPanel>
                                <div className="pl-3 pr-3 flex gap-1 justify-content-center">
                                    <AvatarGroup>
                                        {projectData?.members?.map(memberData => (
                                            <Avatar memberData={memberData.member}/>))}
                                    </AvatarGroup>
                                </div>
                            </div>
                        </div>
                    </CardView>
                </div>
                <div className="flex p-4 pt-0 gap-4">
                    <CardView className="surface-50">
                        <div className="flex gap-2">
                            {/* «منابع پروژه» was replaced by the project's progress chart (boss's task «تغییر هویت پروژه») */}
                            <ProjectProgressChart projectData={projectData} onDefineMilestones={permission.can("create-milestone") ? () => setDeliverableDialogVisible(true) : undefined}/>
                        </div>
                    </CardView>
                </div>
                <div className="flex p-4 pt-0 gap-4">
                    <CardView className="surface-50">
                        <div className="flex gap-2">
                            <div className="flex-1 flex flex-column gap-2 pb-3">
                                <BoxHeader left={
                                    <div className="flex gap-2 align-items-center">
                                        <Button
                                            className="p-button-sm p-button-secondary p-1 pl-2 pr-2 text-xs font-normal p-button-outlined flex gap-1"
                                            icon={<Icon icon="mi mi:add_link" className="text-sm"/>}
                                            label={translate("link")}
                                            onClick={() => {
                                                console.log("clicked");
                                                setAddLinkVisible(true)
                                            }}/>
                                        <Button
                                            className="p-button-sm p-button-secondary p-button-outlined font-normal text-xs p-1 pl-2 pr-2 flex gap-1"
                                            icon={<Icon icon="mi mi:cloud_upload" className="text-sm"/>}
                                            label={translate("google-drive")}/>
                                    </div>} icon={<Icon icon="mi mi:attach_file"
                                                        className="text-lg text-400 text-primary"/>}
                                           title={translate("files-external-resources")} className="text-sm p-3"/>
                                <FilesList attachments={projectData?.attachments} tasks={tasks}
                                           projectData={projectData} updateLinkedAttachments={updateLinkedAttachments}/>
                            </div>

                        </div>
                    </CardView>
                </div>
            </div>

            <div className="w-3 min-h-0 overflow-y-auto scrollbar-hide">
                <ProjectUpdates projectData={projectData}/>
            </div>
            <AddLinkDialog visible={addLinkVisible} setVisible={setAddLinkVisible} onSubmit={(linkData) => {
                console.log("linkData:", linkData)
            }}/>

        </div>
    );
}

function FilesList(props) {
    const translate = useTranslate();
    const [selectedFile, setSelectedFile] = useState()
    const ItemTemplate = (data) => {
        return (
            <div className="w-full p-1">
                <div className="border-round surface-50 border-1 border-100 p-2 flex align-items-center cursor-pointer"
                     onClick={() => {
                         setSelectedFile(data)
                     }}>
                    <div className="flex align-items-center">
                        {fileThumbnail(data.name, resolveUrl(data.url), "2.5rem", true)}
                        <div className="flex flex-column text-xs ">
                            <span className="font-bold">{data.name}</span>
                            <div className="flex align-items-centergap-2 text-2xs text-400">
                                <span>{translate("uploaded-at")}:</span>
                                <Span type="PERSIAN_DATE" format="YYYY/MM/DD">{data.createdAt}</Span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div>
            <DataView emptyMessage={<DatatableEmptyMessage/>} className="px-3" layout="list" itemTemplate={ItemTemplate}
                      value={props.attachments}/>
            <FileSidebar onHide={() => {
                setSelectedFile(undefined)
            }} visible={selectedFile !== undefined} payload={{
                selectedFile: props.attachments?.find(attachment => selectedFile?.id === attachment.id),
                tasks: props.tasks,
                projectData: props.projectData
            }} onChange={(e) => {
                props.updateLinkedAttachments(e)
            }}/>
        </div>
    )
}

function CardView({children, className, onClick}) {
    return (
        <div onClick={onClick}
             className={`${className} h-full text-xs w-full shadow-1 border-round-xl ${onClick && "cursor-pointer hover:surface-50"}`}>
            {children}
        </div>
    )
}

function ProjectUpdates({projectData}) {
    const navigate = useNavigate();
    const translate = useTranslate();
    const cards = [
        {
            label: "on-way",
            value: "on-way",
            data: {
                icon: "mi mi:check",
                className: projectData?.projectStatus === "on-way" && "border-1 border-green-200 bg-green-50",
                iconClassName: "bg-green-100 text-green-500"
            }
        },
        {
            label: "has-risks",
            value: "has-risks",
            data: {
                icon: "mi mi:warning",
                className: projectData?.projectStatus === "has-risks" && "border-1 border-yellow-200 bg-yellow-50",
                iconClassName: "bg-yellow-100 text-yellow-500"
            }
        },
        {
            label: "out-of-way",
            value: "out-of-way",
            data: {
                icon: "mi mi:dangerous",
                className: projectData?.projectStatus === "out-of-way" && "border-1 border-red-200 bg-red-50",
                iconClassName: "bg-red-100 text-red-500"
            }
        },
        {
            label: "achieved",
            value: "achieved",
            data: {
                icon: "mi mi:done_all",
                className: projectData?.projectStatus === "achieved" && "border-1 border-green-200 bg-green-50",
                iconClassName: "bg-green-100 text-green-500"
            }
        },
        {
            label: "canceled",
            value: "canceled",
            data: {
                icon: "mi mi:close",
                className: projectData?.projectStatus === "canceled" && "border-1 border-gray-200 bg-gray-50",
                iconClassName: "bg-gray-100 text-gray-500"
            }
        },
        {
            label: "archived",
            value: "archived",
            data: {
                icon: "mi mi:check_indeterminate_small",
                className: projectData?.projectStatus === "archived" && "border-1 border-red-200 bg-red-50",
                iconClassName: "bg-red-100 text-red-500"
            }
        },
    ]

    const ProjectStatus = (status) => {

        const card = cards.find(c => c.value === status)?.data;

        return (
            <div className="p-1">
                <CardView
                    className={`flex flex-column gap-3 align-items-center justify-content-center p-3 ${card?.className}`}>
                    <div className="flex flex-column gap-2 w-full align-items-center">
                        <PrimeAvatar shape="circle" size="large" className={card?.iconClassName}
                                     icon={<Icon icon={card?.icon}/>}/>
                        <span className="text-400">{translate("current-project-status")}</span>
                        <span
                            className={`${card?.iconClassName} p-1 border-round font-bold w-5 text-center`}>{translate(projectData?.projectStatus)}</span>
                    </div>
                    <Can permission="modify-project-settings"
                         scopeId={projectData?.documentId}
                         scopeRolePermissions={projectData?.rolesConfig}>
                        <Button onClick={() => {
                            navigate(`/projects/${projectData.documentId}/update-status`)
                        }} className="p-button-outlined p-button-secondary p-2 px-3 text-xs"
                                label={translate("update-project-status")}/>
                    </Can>

                </CardView>
            </div>
        )
    }

    const ProjectInfo = (projectData) => {

        return (
            <div className="p-1">
                <CardView
                    className={`flex flex-column align-items-center justify-content-center px-2 pb-2 surface-100`}>
                    <div className="flex w-full border-300 align-items-center gap-2 p-3">
                        <Avatar memberData={projectData?.owner?.member}/>
                        <div className="flex flex-column">
                            <span className="text-2xs">{translate("project-owner")}</span>
                            <span className="font-bold">{projectData?.owner?.member?.fullname}</span>
                        </div>
                    </div>
                    <Divider layout="horizontal" className="m-0"/>
                    <div className="flex justify-content-between w-full">
                        <div className="flex flex-column w-full h-full p-2 justify-content-between">
                            <span className="text-400 text-2xs">{translate("startDate")}
                            </span>
                            <Span spanClassName="text-center w-full font-bold h-fit mt-2" type="PERSIAN_DATE"
                                  format="YYYY/MM/DD">{projectData?.createdAt}</Span>
                        </div>
                        <Divider layout="vertical" className="m-0"/>
                        <div className="flex flex-column w-full h-full p-2 justify-content-between">
                            <span className="text-400 text-2xs">{translate("dueDate")}</span>
                            <Span spanClassName="text-center w-full font-bold h-fit mt-2" type="PERSIAN_DATE"
                                  format="YYYY/MM/DD">{projectData?.dueDate}</Span>
                        </div>
                    </div>
                </CardView>
            </div>
        )
    }

    return (
        <div className="flex flex-column p-3 gap-3">
            {ProjectStatus(projectData?.projectStatus)}
            {ProjectInfo(projectData)}
            <ProjectUpdatesList projectData={projectData}/>
        </div>
    )
}

export default Identification;
